export default "__VITE_ASSET__BV4fwGxP__"